import { styled, TextField } from '@mui/material';

export const TextFieldSelect = styled(TextField)`
  & .MuiSelect-select {
    padding: 0.8rem 3.2rem 0.8rem 1.6rem;
  }
`;
